'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var React = _interopDefault(require('react'));
var PropTypes = _interopDefault(require('prop-types'));
var styled = _interopDefault(require('styled-components'));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var disable = function disable() {
  var customStyles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread({
    borderColor: '#e0e0e0',
    color: '#e0e0e0',
    cursor: 'auto'
  }, customStyles);
};
var disableLabel = function disableLabel() {
  var customStyles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread({
    color: '#e0e0e0'
  }, customStyles);
};
var Container = styled.div.withConfig({
  componentId: "w4fpuo-0"
})(["position:", ";width:", ";height:", ";min-width:", ";max-width:100%;"], function (props) {
  return props.containerStyle.position || 'relative';
}, function (props) {
  return props.containerStyle.width || 'auto';
}, function (props) {
  return props.containerStyle.height || 'auto';
}, function (props) {
  return props.containerStyle.minWidth || '6.25rem';
});
var Label = styled.label.withConfig({
  componentId: "w4fpuo-1"
})(["position:absolute;top:", ";left:", ";font-size:", ";font-weight:", ";color:", ";cursor:", ";"], function (props) {
  return props.labelStyle.top || '.75rem';
}, function (props) {
  return props.labelStyle.left || '.75rem';
}, function (props) {
  return props.labelStyle.fontSize || '0.875rem';
}, function (props) {
  return props.labelStyle.fontWeight || 'inherit';
}, function (props) {
  return props.labelStyle.color || '#a0a0a0';
}, function (props) {
  return props.labelStyle.cursor || 'text';
});
var StyledInput = styled.textarea.withConfig({
  componentId: "w4fpuo-2"
})(["box-sizing:border-box;width:100%;max-width:100%;height:", ";padding-top:", ";padding-right:", ";padding-bottom:", ";padding-left:", ";border-style:", ";border-color:", ";border-width:", ";border-radius:", ";cursor:", ";outline-width:", ";background-color:", ";font-size:", ";color:", ";resize:", ";&:focus{border-color:", ";color:", ";}"], function (props) {
  return props.inputStyle.height || 'auto';
}, function (props) {
  return props.inputStyle.paddingTop || '0.75rem';
}, function (props) {
  return props.inputStyle.paddingRight || '0.75rem';
}, function (props) {
  return props.inputStyle.paddingBottom || '0.75rem';
}, function (props) {
  return props.inputStyle.paddingLeft || '0.75rem';
}, function (props) {
  return props.inputStyle.borderStyle || 'solid';
}, function (props) {
  return props.inputStyle.borderColor || '#999';
}, function (props) {
  return props.inputStyle.borderWidth || '0.0625rem';
}, function (props) {
  return props.inputStyle.borderRadius || '0.125rem';
}, function (props) {
  return props.inputStyle.cursor || 'auto';
}, function (props) {
  return props.inputStyle.outlineWidth || '0';
}, function (props) {
  return props.inputStyle.backgroundColor || 'transparent';
}, function (props) {
  return props.inputStyle.fontSize || '0.875rem';
}, function (props) {
  return props.inputStyle.color || '#000';
}, function (props) {
  return props.inputStyle.resize || '';
}, function (props) {
  return props.inputStyle.focus ? props.inputStyle.focus.borderColor : '#999';
}, function (props) {
  return props.inputStyle.focus ? props.inputStyle.focus.color : '#000';
});
var TextArea = function TextArea(_ref) {
  var id = _ref.id,
    className = _ref.className,
    name = _ref.name,
    disabled = _ref.disabled,
    label = _ref.label,
    value = _ref.value,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    minLength = _ref.minLength,
    maxLength = _ref.maxLength,
    containerStyle = _ref.containerStyle,
    labelStyle = _ref.labelStyle,
    inputStyle = _ref.inputStyle;
  return /*#__PURE__*/React.createElement(Container, {
    containerStyle: containerStyle,
    className: className
  }, /*#__PURE__*/React.createElement(Label, {
    htmlFor: id,
    labelStyle: disabled ? disableLabel(labelStyle) : labelStyle
  }, !value && label), /*#__PURE__*/React.createElement(StyledInput, {
    id: id,
    inputStyle: disabled ? disable(inputStyle) : inputStyle,
    name: name,
    type: "text",
    disabled: disabled,
    value: value,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    minLength: minLength,
    maxLength: maxLength
  }));
};
TextArea.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  maxLength: PropTypes.number,
  minLength: PropTypes.number,
  containerStyle: PropTypes.shape({
    position: PropTypes.string,
    width: PropTypes.string,
    minWidth: PropTypes.string,
    height: PropTypes.string
  }),
  labelStyle: PropTypes.shape({
    top: PropTypes.string,
    left: PropTypes.string,
    fontSize: PropTypes.string,
    fontWeight: PropTypes.string,
    color: PropTypes.string
  }),
  inputStyle: PropTypes.shape({
    resize: PropTypes.string,
    height: PropTypes.string,
    borderStyle: PropTypes.string,
    borderColor: PropTypes.string,
    borderWidth: PropTypes.string,
    borderRadius: PropTypes.string,
    paddingTop: PropTypes.string,
    paddingBottom: PropTypes.string,
    paddingLeft: PropTypes.string,
    paddingRight: PropTypes.string,
    cursor: PropTypes.string,
    outlineWidth: PropTypes.string,
    backgroundColor: PropTypes.string,
    fontSize: PropTypes.string,
    color: PropTypes.string,
    focus: PropTypes.shape({
      borderColor: PropTypes.string,
      color: PropTypes.string
    })
  })
};
TextArea.defaultProps = {
  className: '',
  name: '',
  disabled: false,
  label: '',
  value: undefined,
  onChange: function onChange() {
    return undefined;
  },
  onFocus: function onFocus() {
    return undefined;
  },
  onBlur: function onBlur() {
    return undefined;
  },
  maxLength: undefined,
  minLength: undefined,
  containerStyle: {},
  labelStyle: {},
  inputStyle: {}
};

exports.default = TextArea;
exports.disable = disable;
exports.disableLabel = disableLabel;
